import script from "./ResultsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ResultsDashboard.vue?vue&type=style&index=0&id=3dadd5da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dadd5da"]])

export default __exports__